// Import the date-fns library
import { format } from 'date-fns';

document.addEventListener('DOMContentLoaded', function() {
  let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const calendarSelect = document.querySelector('#calendar-select');
  if ( calendarSelect ) {
    calendarSelect.addEventListener("change", function() {
      const selectedCalendar = this.value;

      // If the user clicks "OK", proceed with the logic
      if ( selectedCalendar != '' ) {
        // Get the event details from the data attributes
        const title = this.getAttribute('title');
        const dates = JSON.parse(decodeURIComponent(this.getAttribute('dates'))); // Decode the URL-encoded string and then parse it as JSON
        const location = this.getAttribute('location');
        const details = this.getAttribute('details');

        // Ensure the button container is empty and hidden before proceeding
        resetButtonContainer();

        // Define the userConfirmed variable
        let userConfirmed;

        // Get the keys of the dates object
        const datesKeys = Object.keys(dates);
        const hasMultipleDates = datesKeys.length > 1;

        // If the event has multiple dates, display a message to the user complete with the buttons to add the event to the calendar
        if ( hasMultipleDates ) {
          userConfirmed = true;
        }
        // Otherwise, prompt the user to confirm the add to calendar action
        else {
          // Display a confirmation prompt
          userConfirmed = window.confirm("Are you sure you want to add this event to your " + selectedCalendar + " calendar?");
        }

        // If the user has confirmed or the event has multiple dates, proceed with the logic
        if ( userConfirmed ) {
          // Define the event details object
          let eventDetails = {
            'title': title,
            'location': location,
            'details': details,
            'dates': dates,
          };

          // Handle the selected calendar
          switch ( selectedCalendar ) {
            // Handle Google Calendar
            case 'google':
              if ( hasMultipleDates ) {
                // Display the button containing the Google Calendar link for each date and on click open the link in a new tab
                populateCalendarButtons(eventDetails, selectedCalendar);
              }
              else {
                // Set the start and end dates to the first date in the array
                eventDetails.start = dates[0].start;
                eventDetails.end = dates[0].end;
                // Get and open the Google Calendar link
                let googleCalendarLink = generateGoogleCalendarLink(eventDetails);
                window.open(googleCalendarLink, '_blank');
              }
              break;

            // Handle iCalendar
            case 'ical':
              //downloadICSFile(eventDetails);
              openInCalendar(eventDetails);
              break;

            // Handle Outlook 365
            case 'outlook365':
              if ( hasMultipleDates ) {
                // Display the button containing the Google Calendar link for each date and on click open the link in a new tab
                populateCalendarButtons(eventDetails, selectedCalendar);
              }
              else {
                // Set the start and end dates to the first date in the array
                eventDetails.start = dates[0].start;
                eventDetails.end = dates[0].end;
                // Get and open the Outlook link
                let outlook365Link = generateOutlookLink(eventDetails, '365');
                window.open(outlook365Link, '_blank');
              }
              break;

            // Handle Outlook Live
            case 'outlooklive':
              if ( hasMultipleDates ) {
                // Display the button containing the Google Calendar link for each date and on click open the link in a new tab
                populateCalendarButtons(eventDetails, selectedCalendar);
              }
              else {
                // Set the start and end dates to the first date in the array
                eventDetails.start = dates[0].start;
                eventDetails.end = dates[0].end;
                // Get and open the Outlook link
                let outlookLiveLink = generateOutlookLink(eventDetails, 'live');
                window.open(outlookLiveLink, '_blank');
              }
              break;
          }
        }
      }
      else {
        // If the user clicks "Cancel", reset the select menu and return
        this.value = '';
      }
    });
  }

  function formatGoogleDate(dateString) {
    const eventTimeInUTC = new Date(dateString);
    return format(eventTimeInUTC, "yyyyMMdd'T'HHmmss'X'", { timeZone: 'UTC' });
  }

  function generateGoogleCalendarLink( event ) {
    let baseLink = 'https://www.google.com/calendar/render?action=TEMPLATE';
    baseLink += '&text=' + encodeURIComponent(event.title);
    baseLink += '&dates=' + formatGoogleDate(event.start) + '/' + formatGoogleDate(event.end);
    baseLink += '&location=' + encodeURIComponent(event.location);
    baseLink += '&details=' + encodeURIComponent(event.details);
    return baseLink;
  }

  function generateICSContent(event) {
    let icsContent = "BEGIN:VCALENDAR\r\nVERSION:2.0\r\n";
    Object.values(event.dates).forEach(date => {
      icsContent += "BEGIN:VEVENT\r\n";
      icsContent += "DTSTART:TZID=" + userTimeZone + ":" + formatICSDate(date.start) + "\r\n";
      icsContent += "DTEND:TZID=" + userTimeZone + ":" + formatICSDate(date.end) + "\r\n";
      icsContent += "LOCATION:" + event.location + "\r\n";
      icsContent += "SUMMARY:" + event.title + "\r\n";
      icsContent += "DESCRIPTION:" + event.details + "\r\n";
      icsContent += "END:VEVENT\r\n";
    });
    icsContent += "END:VCALENDAR\r\n";
    return icsContent;
  }

  function formatICSDate(dateString) {
    const eventTimeInUTC = new Date(dateString);
    return format(eventTimeInUTC, "yyyyMMdd'T'HHmmss'X'", { timeZone: 'UTC' });
  }

  function generateOutlookLink(event, type) {
    let baseLink = '';
    switch ( type ) {
      case '365':
        baseLink = 'https://outlook.office365.com/owa/?path=/calendar/action/compose';
        break;
      case 'live':
        baseLink = 'https://outlook.live.com/owa/?path=/calendar/action/compose';
        break;
    }
    baseLink += '&subject=' + encodeURIComponent(event.title);
    baseLink += '&startdt=' + encodeURIComponent(formatOutlookDate(event.start));
    baseLink += '&enddt=' + encodeURIComponent(formatOutlookDate(event.end));
    baseLink += '&location=' + encodeURIComponent(event.location);
    baseLink += '&body=' + encodeURIComponent(event.details);
    return baseLink;
  }

  function formatOutlookDate(dateString) {
    const eventTimeInUTC = new Date(dateString);
    return format(eventTimeInUTC, "yyyy-MM-dd'T'HH:mm:ss'X'", { timeZone: 'UTC' });
  }

  function downloadICSFile(event) {
    const icsContent = generateICSContent(event);
    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8;' });
    const url = window.URL || window.webkitURL;
    const downloadUrl = url.createObjectURL(blob);
    let downloadLink = document.createElement('a');

    downloadLink.href = downloadUrl;
    downloadLink.download = 'event.ics';

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  function openInCalendar(event) {
    var icsContent = generateICSContent(event);
    var encodedContent = encodeURIComponent(icsContent);
    var dataUrl = 'data:text/calendar;charset=utf8,' + encodedContent;
    window.location.href = dataUrl;
  }

  function resetButtonContainer() {
    document.getElementById('add-to-calendar-buttons').innerHTML = '';
    document.getElementById('button-container').style.display = 'none';
  }

  function populateCalendarButtons(eventDetails, selectedCalendar) {
    // For each date in the dates object, create a button
    Object.values(eventDetails.dates).forEach((date, index) => {
      // Set the start and end dates for the current date
      eventDetails.start = date.start;
      eventDetails.end = date.end;

      let link;
      switch (selectedCalendar) {
        case 'google':
          link = generateGoogleCalendarLink(eventDetails);
          break;
        case 'outlook365':
          link = generateOutlookLink(eventDetails, '365');
          break;
        case 'outlooklive':
          link = generateOutlookLink(eventDetails, 'live');
          break;
      }

      if ( link ) {
        // Define the days and months arrays
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        // Parse the start datetime from ISO8601UTC to a human-readable date sans time format
        const startDate = new Date(date.start);

        // Extract the day, date, month, and year components
        const day = days[startDate.getDay()];
        const month = months[startDate.getMonth()];
        const dateNum = startDate.getDate();
        // Format the date to a human-readable string
        const formattedDate = `${day}, ${month} ${dateNum}`;
        // Create a button for each date
        createButtonForDate(`Add ${formattedDate}`, link);
      }
    });
  }

  function createButtonForDate(text, url) {
    const button = document.createElement('button');
    button.textContent = text;
    button.classList.add('gs-add-to-calendar-button');
    button.onclick = function() {
      window.open(url, '_blank');
    };

    // Append the button to a specific element, e.g., a div with the ID 'buttonContainer'
    document.getElementById('add-to-calendar-buttons').appendChild(button);
    document.getElementById('button-container').style.display = 'block';
  }

});
